document.addEventListener('DOMContentLoaded', () => {
  const heroSlideshows = document.querySelectorAll(
    'slideshow-component:has(.slideshow__hero-image-container)'
  );

  heroSlideshows.forEach((slideshow) => {
    const slides = Array.from(
      slideshow.querySelectorAll('.slideshow__slide')
    );

    if (slides.length < 2) return;

    let currentIndex = slides.findIndex(
      (slide) => slide.getAttribute('aria-hidden') === 'false'
    );

    if (currentIndex < 0) currentIndex = 0;

    // Initialize state cleanly
    slides.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index === currentIndex ? 'false' : 'true');
      slide.tabIndex = index === currentIndex ? 0 : -1;
    });

    const intervalMs = 4000; // 5 seconds
    let intervalId = null;

    const goToSlide = (nextIndex) => {
      slides[currentIndex].setAttribute('aria-hidden', 'true');
      slides[currentIndex].tabIndex = -1;

      slides[nextIndex].setAttribute('aria-hidden', 'false');
      slides[nextIndex].tabIndex = 0;

      currentIndex = nextIndex;
    };

    const startRotation = () => {
      intervalId = setInterval(() => {
        const nextIndex = (currentIndex + 1) % slides.length;
        goToSlide(nextIndex);
      }, intervalMs);
    };

    const stopRotation = () => {
      if (intervalId) clearInterval(intervalId);
    };

    startRotation();

    // Optional: pause on hover
    slideshow.addEventListener('mouseenter', stopRotation);
    slideshow.addEventListener('mouseleave', startRotation);
  });
});

document.addEventListener('DOMContentLoaded', function () {
  function fitHeroHeadings() {
    var slideshows = document.querySelectorAll('slideshow-component');

    for (var i = 0; i < slideshows.length; i++) {
      if (!slideshows[i].querySelector('.slideshow__hero-image-container')) continue;

      var headings = slideshows[i].querySelectorAll('.banner__heading');

      for (var j = 0; j < headings.length; j++) {
        var heading = headings[j];
        var parent = heading.parentElement;

        if (!parent) continue;

        heading.style.fontSize = '';
        var maxSize = 112;
        var minSize = 42;
        var size = minSize;

        heading.style.fontSize = size + 'px';

        while (size < maxSize && heading.scrollWidth <= parent.clientWidth-1) {
          size += 1;
          heading.style.fontSize = size + 'px';
        }
      }
    }
  }

  fitHeroHeadings();
  window.addEventListener('resize', fitHeroHeadings);
});